
/* ___START___ Add recommendationsAPI recomendations to quick cart */
document.addEventListener("DOMContentLoaded", function() {

    const getCart = async function(){
        const response = await fetch('/cart.js');
        return  await response.json();
    };

    const loadRecommendedProducts = async function () {

        const cart = await getCart();

        let productID = null;

        if(cart.items && cart.items.length){

            productID = cart.items[0].product_id;
        }else{
            return false;
        }

        let productRecommendationsSection = document.querySelectorAll('.product-recommendations');

        // replace the product_id with the first product id in the cart
        let urlParams = new URLSearchParams(productRecommendationsSection[0].dataset.url);

        urlParams.product_id = productID;

        // const url = productRecommendationsSection.dataset.url;
        const url = decodeURIComponent(urlParams.toString());

        fetch(url)
            .then(response => response.text())
            .then(text => {

                const html = document.createElement('div');
                html.innerHTML = text;
                const recommendations = html.querySelector('.product-recommendations');

                if (recommendations && recommendations.innerHTML.trim().length) {

                    productRecommendationsSection.forEach( function(el){

                        el.innerHTML = recommendations.innerHTML;
                    } );

                }

                document.querySelectorAll('.product-recommendations .mycross-sells__item-add.btn').forEach(function (el) {

                    el.addEventListener('click', function (e) {

                        // let productId = el.closest('form').dataset.currentProductId;
                        let productId = el.dataset.addItemId;

                        let formData = {
                            'items': [{
                                'id': productId, 'quantity': 1
                            }]
                        };

                        // debugger;

                        fetch(window.Shopify.routes.root + 'cart/add.js', {
                            method: 'POST', headers: {
                                'Content-Type': 'application/json'
                            }, body: JSON.stringify(formData)
                        })
                            .then(response => {

                                // if this was a click on the main cart ... just reload the cart page - otherwise trigger the minicart reload
                                if(el.closest('.shopify-section.cart-section')){
                                    window.location.reload();
                                }else{
                                    document.dispatchEvent(new CustomEvent('apps:product-added-to-cart'));
                                }
                                return response.json();

                            })
                            .catch((error) => {
                                console.error('Error:', error);
                            });
                    });
                });


            })
            .catch(e => {
                console.error(e);
            });
    };

    const handleIntersection = (entries, observer) => {

        if (!entries[0].isIntersecting) return;
        // observer.unobserve(productRecommendationsSection);
        loadRecommendedProducts();

    };

    let intersectionObserverAdded = false;

    const addIntersectionObserver = function(){

        const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});
        let target = document.querySelector('.product-recommendations');

        if(target){
            observer.observe(target )
            intersectionObserverAdded = true;
        }

    };

    // document.addEventListener('apps:product-added-to-cart', function () {
    //     window.setTimeout( function(){ loadRecommendedProducts(); }, 1000 );
    // });

    document.addEventListener('cart:item-added', function () {
        /*
         if there was nothing in the cart - the intersection observer wont have been added cause the element wouldnt have existed, so add it once the cart is activated once item is added
         */
        if(! intersectionObserverAdded){
            addIntersectionObserver();
        }
    });

    addIntersectionObserver();

    // if this is the '/cart' page - run loadRecommendedProducts() at page load and respon to cart modifications

    if( document.querySelector('body.template-cart') ){

        // load recommended products on page load
        window.setTimeout( function(){ loadRecommendedProducts(); }, 250 );
    }


    // Select the node that will be observed for mutations
    const mainCartSection = document.querySelector(".main .cart-section");
    const quickCartSection = document.querySelector(".shopify-section .quick-cart");

    // Options for the observer (which mutations to observe)
    const config = {  childList: true, subtree: true  };

    // Callback function to execute when mutations are observed
    const callback = (mutationList, observer) => {

        let donereload = false;

        for (const mutation of mutationList) {

            if( ! donereload && ! mutation.target.classList.contains('product-recommendations') ){
                window.setTimeout( function(){ loadRecommendedProducts(); }, 250 );
                donereload = true;
            }
        }

    };

    // Create an observer instance linked to the callback function
    const observer = new MutationObserver(callback);

    // Start observing the target node for configured mutations
    if (mainCartSection){
        observer.observe(mainCartSection, config);
    }

    if(quickCartSection){

        observer.observe(quickCartSection, config);
    }


});

/* ___END___ Add recommendationsAPI recomendations to quick cart */



/*
* Account
* */
document.addEventListener("DOMContentLoaded", function () {
    // Cache elements
    var accountLinks = document.querySelectorAll('[data-account-menu]');
    var mobileAccountBtn = document.querySelector('.mobile-account-btn');

    if (!mobileAccountBtn) {
        return null;
    }

    var menuArrow = mobileAccountBtn.querySelector('.menu-arrow');
    var accountMenu = mobileAccountBtn.nextElementSibling;

    // Handle tab switching and menu closing
    accountLinks.forEach(function (link) {
        link.addEventListener('click', function (event) {
            event.preventDefault();

            var accountId = link.getAttribute('data-account-menu');
            var allTabs = document.querySelectorAll('.account-tab');

            // Hide all tabs and remove active state from links
            allTabs.forEach(function (tab) {
                tab.classList.remove('open');
            });
            accountLinks.forEach(function (otherLink) {
                otherLink.classList.remove('active');
            });

            // Show selected tab and update button content
            var selectedTab = document.getElementById(accountId);
            if (selectedTab) {
                selectedTab.classList.add('open');
                link.classList.add('active');

                // Update button content while keeping the arrow intact
                mobileAccountBtn.innerHTML = link.innerHTML;
                mobileAccountBtn.appendChild(menuArrow);
            }

            // Close the menu and rotate the arrow back smoothly
            accountMenu.classList.remove('open');
            menuArrow.classList.remove('rotate');
        });
    });

    // Handle menu toggle
    mobileAccountBtn.addEventListener('click', function (event) {
        event.preventDefault();
        accountMenu.classList.toggle('open');

        // Toggle arrow rotation
        menuArrow.classList.toggle('rotate');
    });
});

document.addEventListener('DOMContentLoaded', function () {
    // Get the .account__menu element
    var accountMenu = document.querySelector('.account__menu');

    if (!accountMenu) {
        return null;
    }

    // Add click event listener to all <a> tags within .account__menu
    accountMenu.addEventListener('click', function (event) {
        // Check if the clicked element is an <a> tag
        if (event.target.tagName === 'A') {
            // Remove the 'open' class from .account__menu
            accountMenu.classList.remove('open');
        }
    });
});

document.querySelectorAll('.product-item').forEach(item => {
  const h4 = item.querySelector('h4');
  if (!h4) return;

  const text = h4.textContent.toUpperCase();

  if (text.includes('FOCUS')) {
    item.style.color = '#b1be15';
  } else if (text.includes('CHILL')) {
    item.style.color = '#FF5C06';
  } else if (text.includes('SLEEP')) {
    item.style.color = '#5217D9';
  } else if (text.includes('POWER')) {
    item.style.color = '#fe4e7c';
  }
});

document.querySelectorAll('.product__title').forEach(title => {
  const text = title.textContent.toUpperCase();

  if (text.includes('FOCUS')) {
    title.style.color = '#b1be15';
  } else if (text.includes('CHILL')) {
    title.style.color = '#FF5C06';
  } else if (text.includes('SLEEP')) {
    title.style.color = '#5217D9';
  } else if (text.includes('POWER')) {
    title.style.color = '#fe4e7c';
  }
});

document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".video-with-text__video-wrapper").forEach(wrapper => {
        const video = wrapper.querySelector("video");
        const overlay = wrapper.querySelector(".video__overlay");

        if (!video || !overlay) return;

        overlay.addEventListener("click", () => {
            video.play();
        });

        video.addEventListener("play", () => {
            overlay.remove();
        });
    });
});